import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import { DialogContent } from '@mui/material';
import { TDeleteDialogProps } from './types';

export const NoticeDialog: FC<TDeleteDialogProps> = ({ open, setClose, title, children }) => {
	return (
		<Dialog open={open} onClose={setClose}>
			<DialogTitle color="primary">{title}</DialogTitle>
			<DialogContent>{children}</DialogContent>
			<DialogActions>
				<Button onClick={setClose}>Close</Button>
			</DialogActions>
		</Dialog>
	);
};
